import {Injectable} from '@angular/core';
import {BaseOPEService} from "./BaseOPEService";
import {GetExternalApplicationCB} from "../../ope/external-application/GetExternalApplicationCB";
import {DelExternalApplicationCB} from "../../ope/external-application/DelExternalApplicationCB";
import {PutExternalApplicationCB} from "../../ope/external-application/PutExternalApplicationCB";
import {ChangeExternalApplicationSecretCB} from "../../ope/external-application/ChangeExternalApplicationSecretCB";
import {GetExternalApplicationApiCallsLogCB} from "../../ope/external-application/GetExternalApplicationApiCallsLogCB";
import {UpdateExternalApplicationCB} from "../../ope/external-application/UpdateExternalApplicationPartitionCB";

@Injectable({
  providedIn: 'root'
})
export class ExternalApplicationOpeService extends BaseOPEService {

  public getExternalApplication(cb: GetExternalApplicationCB): Promise<any> {
    return this.execOPE(cb);
  }

  public getExternalApiCallsLog(cb: GetExternalApplicationApiCallsLogCB): Promise<any> {
    return this.execOPE(cb);
  }

  public putExternalApplication(cb: PutExternalApplicationCB): Promise<any> {
    return this.execOPE(cb);
  }

  public changeExternalApplicationSecret(cb: ChangeExternalApplicationSecretCB): Promise<any> {
    return this.execOPE(cb);
  }

  public delExternalApplication(cb: DelExternalApplicationCB): Promise<any> {
    return this.execOPE(cb);
  }

  public updateExternalApplicationPartition(cb: UpdateExternalApplicationCB): Promise<any> {
    return this.execOPE(cb);
  }
}
